<template>
    <article>
        <p>
            This inspection identifies issues with the availability and latency of Postgres instances.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspections/postgres.png" />
        </v-card>
        
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
